import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/** 响应错误的规范 */

export var DriveApiError = /*#__PURE__*/function (_Error) {
  _inherits(DriveApiError, _Error);
  var _super = _createSuper(DriveApiError);
  function DriveApiError(options) {
    var _options$params, _options$payload, _options$response, _options$context;
    var _this;
    _classCallCheck(this, DriveApiError);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "params", null);
    _defineProperty(_assertThisInitialized(_this), "payload", null);
    _defineProperty(_assertThisInitialized(_this), "response", null);
    _defineProperty(_assertThisInitialized(_this), "context", null);
    _this.name = "[DriveApi]: ".concat(options.name);
    _this.params = (_options$params = options.params) !== null && _options$params !== void 0 ? _options$params : null;
    _this.payload = (_options$payload = options.payload) !== null && _options$payload !== void 0 ? _options$payload : null;
    _this.response = (_options$response = options.response) !== null && _options$response !== void 0 ? _options$response : null;
    _this.context = (_options$context = options.context) !== null && _options$context !== void 0 ? _options$context : null;
    _this.message = options.message;
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(_assertThisInitialized(_this), DriveApiError.prototype);
    return _this;
  }
  return _createClass(DriveApiError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=error.js.map